const buttonStyle = {
  button: {
    borderRadius: '8px',
    padding: '15px 30px',
    color: '#fff',
    fontFamily: 'Source Sans Pro',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
  },
  grayButton: {
    borderRadius: '8px',
    padding: '15px 30px',
    color: 'rgba(128, 30, 222, 1)',
    fontFamily: 'Source Sans Pro',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
  },
  yellowColor: {
    backgroundImage: 'linear-gradient(180deg, #F59000 0.2%, #E76300 100%)',
  },
  grayColor: {
    backgroundImage: 'linear-gradient(180deg, #FFFFFF 0.2%, #C5BBEC 100%)',
    color: 'rgba(128, 30, 222, 1) !important',
  },
  indigoColor: {
    backgroundImage: 'linear-gradient(180deg, #333375 0.2%, #333375 100%)',
  },
}

export default buttonStyle
